import Logger from '../../common/Logger';

export function shouldTrack(
  eventType: 'click' | 'impression',
  telemetryEvents?: ('click' | 'impression')[]
): boolean {
  return (telemetryEvents ?? []).includes(eventType);
}

export function telemetryClickHandler(
  telemetrySlug?: string,
  telemetryEvents?: ('click' | 'impression')[]
): (() => void) | undefined {
  return telemetrySlug && shouldTrack('click', telemetryEvents)
    ? () => Logger.accessTelemetry().increment(`${telemetrySlug}.click`)
    : undefined;
}

export function telemetryImpressionHandler(
  telemetrySlug?: string,
  telemetryEvents?: ('click' | 'impression')[]
): void {
  if (telemetrySlug && shouldTrack('impression', telemetryEvents)) {
    Logger.accessTelemetry().increment(`${telemetrySlug}.impression`);
  }
}
